export default "__VITE_ASSET__$SELJGSv__"